import React from "react";

const Fixed = () => {
  return (
    <div>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4520_10669)">
          <path
            opacity="0.48"
            d="M48 0H24C10.7452 0 0 10.7452 0 24V48C0 61.2548 10.7452 72 24 72H48C61.2548 72 72 61.2548 72 48V24C72 10.7452 61.2548 0 48 0Z"
            fill="#54B4FD"
          />
          <g filter="url(#filter0_d_4520_10669)">
            <path
              d="M36 60C49.2548 60 60 49.2548 60 36C60 22.7452 49.2548 12 36 12C22.7452 12 12 22.7452 12 36C12 49.2548 22.7452 60 36 60Z"
              fill="white"
            />
          </g>
          <path
            d="M45.41 35.41L36.58 26.58C36.205 26.2081 35.6982 25.9996 35.17 26H28C27.4701 26.0016 26.9623 26.2128 26.5875 26.5875C26.2128 26.9623 26.0016 27.4701 26 28V35.17C25.9992 35.4325 26.051 35.6925 26.1524 35.9347C26.2537 36.1769 26.4025 36.3963 26.59 36.58L35.42 45.41C35.6058 45.596 35.8263 45.7435 36.0691 45.8441C36.3119 45.9448 36.5722 45.9966 36.835 45.9966C37.0978 45.9966 37.3581 45.9448 37.6009 45.8441C37.8437 45.7435 38.0643 45.596 38.25 45.41L45.42 38.24C45.6053 38.0536 45.752 37.8325 45.8518 37.5893C45.9516 37.3462 46.0025 37.0858 46.0016 36.8229C46.0007 36.5601 45.9479 36.3 45.8464 36.0576C45.7449 35.8151 45.5966 35.5951 45.41 35.41ZM30.5 32C30.2033 32 29.9133 31.912 29.6667 31.7472C29.42 31.5824 29.2277 31.3481 29.1142 31.074C29.0007 30.7999 28.971 30.4983 29.0288 30.2074C29.0867 29.9164 29.2296 29.6491 29.4393 29.4393C29.6491 29.2296 29.9164 29.0867 30.2074 29.0288C30.4983 28.9709 30.7999 29.0006 31.074 29.1142C31.3481 29.2277 31.5824 29.42 31.7472 29.6666C31.912 29.9133 32 30.2033 32 30.5C32 30.8978 31.842 31.2794 31.5607 31.5607C31.2794 31.842 30.8978 32 30.5 32Z"
            fill="#292929"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_4520_10669"
            x="6"
            y="9"
            width="60"
            height="60"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4520_10669"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4520_10669"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_4520_10669">
            <rect width="72" height="72" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default Fixed;
